import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Users, Copy, Share2, Star } from 'lucide-react';
import { toast } from 'sonner';

export const ReferralSection = ({ referral }) => {
  return (
    <Card className="border border-emerald-500/20 bg-gradient-to-br from-[#0a1a0a]/80 to-[#111] shadow-xl" data-testid="referral-card">
      <CardContent className="p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 rounded-xl bg-emerald-500/20 flex items-center justify-center">
            <Users className="w-5 h-5 text-emerald-400" />
          </div>
          <div>
            <h3 className="text-white font-semibold text-base">Programa de Referidos</h3>
            <p className="text-gray-500 text-xs">Comparte y gana 1 mes extra por cada referido</p>
          </div>
        </div>

        <div className="bg-white/5 rounded-xl p-4 border border-white/10 mb-4">
          <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-2">Tu codigo de referido</p>
          <div className="flex items-center gap-3">
            <p className="text-white text-xl font-bold font-mono tracking-wider flex-1" data-testid="referral-code">{referral.referral_code}</p>
            <Button size="sm" variant="ghost" className="text-gray-400 hover:text-white hover:bg-white/10"
              onClick={() => { navigator.clipboard.writeText(referral.referral_code); toast.success('Codigo copiado'); }} data-testid="copy-referral-code">
              <Copy className="w-4 h-4" />
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 mb-5">
          <div className="bg-white/5 rounded-lg p-3 text-center border border-white/5">
            <p className="text-emerald-400 text-2xl font-bold" data-testid="referral-count">{referral.referral_count}</p>
            <p className="text-gray-500 text-[10px] tracking-wide uppercase">Referidos</p>
          </div>
          <div className="bg-white/5 rounded-lg p-3 text-center border border-white/5">
            <p className="text-[#FFD700] text-2xl font-bold" data-testid="referral-bonus-days">+{referral.referral_bonus_days}</p>
            <p className="text-gray-500 text-[10px] tracking-wide uppercase">Dias ganados</p>
          </div>
          <div className="bg-white/5 rounded-lg p-3 text-center border border-white/5">
            <p className="text-white text-2xl font-bold"><Star className="w-6 h-6 inline text-[#FFD700]" /></p>
            <p className="text-gray-500 text-[10px] tracking-wide uppercase">30 dias/ref</p>
          </div>
        </div>

        {referral.referrals?.length > 0 && (
          <div className="mb-5 space-y-2">
            <p className="text-gray-500 text-xs uppercase tracking-wide mb-2">Tus referidos</p>
            {referral.referrals.map((ref) => (
              <div key={ref.name} className="flex items-center justify-between bg-white/5 rounded-lg px-3 py-2 border border-white/5">
                <span className="text-white text-sm">{ref.name}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${ref.purchased ? 'bg-emerald-500/20 text-emerald-400' : 'bg-amber-500/20 text-amber-400'}`}>
                  {ref.purchased ? '+30 dias' : 'Pendiente'}
                </span>
              </div>
            ))}
          </div>
        )}

        <div className="flex gap-3">
          <a href={`https://wa.me/?text=${encodeURIComponent(`*¡Una emergencia no avisa, pero tú sí puedes prevenir!* 🚑\n\n¿Sabías que una ambulancia particular cuesta entre *$3,900 y $4,500 pesos*?\n\nCon la *Membresía SOS FindMed* tienes:\n✅ 1 Servicio de emergencia al año\n✅ Atención inmediata 24/7\n✅ Cobertura para ti, tu familia o para regalo\n\n🔥 *PRECIO ESPECIAL: Solo $899 pesos* (¡Ahorras más del 75%!)\n\nUsa mi código *${referral.referral_code}* al registrarte y ambos ganamos.\n\n👉 ${referral.share_url}\n\n*FindMed — LO PRIMERO ERES TÚ* 🛡️`)}`}
            target="_blank" rel="noopener noreferrer" className="flex-1">
            <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="share-whatsapp-btn">
              <Share2 className="w-4 h-4 mr-2" />WhatsApp
            </Button>
          </a>
          <Button className="flex-1 bg-white/10 hover:bg-white/20 text-white border border-white/10"
            onClick={() => {
              navigator.clipboard.writeText(`¡Una emergencia no avisa, pero tú sí puedes prevenir! 🚑\n\n¿Sabías que una ambulancia particular cuesta entre $3,900 y $4,500 pesos?\n\nCon la Membresía SOS FindMed tienes:\n✅ 1 Servicio de emergencia al año\n✅ Atención inmediata 24/7\n✅ Cobertura para ti, tu familia o para regalo\n\n🔥 PRECIO ESPECIAL: Solo $899 pesos (¡Ahorras más del 75%!)\n\nUsa mi código ${referral.referral_code} al registrarte y ambos ganamos.\n\n👉 ${referral.share_url}\n\nFindMed — LO PRIMERO ERES TÚ 🛡️`);
              toast.success('Mensaje copiado al portapapeles');
            }} data-testid="copy-share-link">
            <Copy className="w-4 h-4 mr-2" />Copiar Mensaje
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
